import { useState } from "react";
import { api, errMsg } from "../lib/api";
import { ActionButton, Field, FormDialog, TextInput } from "./common";

export const PasswordRecovery = ({ initialEmail, accountType, companyId }) => {
  const [open, setOpen] = useState(false), [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false), [message, setMessage] = useState(""), [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim(), account_type: accountType, ...(companyId?.trim() ? { tenant_id: companyId.trim() } : {}) });
      setMessage(data.message);
    } catch (e) { setError(errMsg(e)); }
    finally { setBusy(false); }
  };
  return <>
    <button type="button" data-testid="forgot-password-button" onClick={() => { setEmail(initialEmail); setMessage(""); setError(""); setOpen(true); }} className="text-sm text-amber-600 underline underline-offset-4 hover:text-amber-500">Forgot password?</button>
    <FormDialog open={open} onOpenChange={(value) => { if (!busy) setOpen(value); }} title="Reset your password" testId="forgot-password-dialog" className="w-[calc(100%_-_2rem)] max-w-lg">
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
        <p className="text-sm text-slate-500" data-testid="forgot-password-account-type">{accountType === "requestor" ? "Requester portal account" : "Team / driver account"} · Reset links expire after one hour</p>
        <Field label="Account email"><TextInput testId="forgot-password-email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required disabled={busy} autoComplete="email" /></Field>
        {message && <p data-testid="forgot-password-confirmation" role="status" className="text-sm text-emerald-700">{message}</p>}
        {error && <p data-testid="forgot-password-error" role="alert" className="text-sm text-red-700">{error}</p>}
        <ActionButton type="submit" testId="forgot-password-submit" disabled={busy || !!message} className="w-full justify-center">{busy ? "Requesting…" : "Send Reset Link"}</ActionButton>
      </form>
    </FormDialog>
  </>;
};
